import type React from 'react';
import { Icon, TEInput } from '@timeedit/ui-components';
import { Typography } from '@timeedit/ui-components/antd';
import type { SwitchProps } from '@timeedit/ui-components/antd';
import './SwitchItem.scss';

type TSwitchProps = SwitchProps & {
  key: React.Key;
  label: string;
};

type SwitchItemProps = {
  label: string;
  url?: string;
  onDelete?: () => void;
  switches: TSwitchProps[];
};

const SwitchItem = ({
  label,
  switches,
  onDelete,
  url,
  ...rest
}: SwitchItemProps) => {
  return (
    <div className="switch-item" {...rest}>
      {url ? (
        <Typography.Link href={url} target="_blank" ellipsis>
          {label}
        </Typography.Link>
      ) : (
        <Typography.Text ellipsis>{label}</Typography.Text>
      )}
      <div className="switch-wrapper">
        {switches.map((switcher) => {
          const {
            size, // TEInput.Switch needs size as a SizeType, not SwitchSize - "middle" will be converted to "default"
            ...switcherProps
          } = switcher;
          return (
            <TEInput.Switch
              size={size === 'small' ? 'small' : 'middle'}
              key={switcher.key}
              {...switcherProps}
            />
          );
        })}
        {onDelete && (
          <Icon id="DeleteOutlined" alt="Delete" onClick={onDelete} />
        )}
      </div>
    </div>
  );
};

export default SwitchItem;
